import React, {Component} from 'react';
import { Button, message } from 'antd';
import Title from '../common/title';
import InterviewQues from '../subPages/interviewQues';
import OtherVideo from '../subPages/otherVideo';
import {ajax} from '../../../../utils/common';

class QueVideo extends Component {
  state = {
    autoPlay: false,
    showLoading: false,
    selectedIndex: 0
  }

  // 生成报告
  generateReport = () => {
    const { i18n } = this.props,
      { showLoading } = this.state;
    if(showLoading) return false;
    this.setState({
      showLoading: true
    });
    ajax({
      url: "/account/analyzeExpression"
    }).then(res => {
      message.success(i18n.report.generate);
      this.setState({
        showLoading: false
      });
    }).catch(err => {
      message.error(err.message || i18n.report.reportFail);
      this.setState({
        showLoading: false
      });
    });
  }

  handleClick = (qId, index, autoPlay) => {
    //设置选中题号
    this.setState({
      selectedIndex: index,
      autoPlay: autoPlay || false
    });
    this.props.handleClick(qId);
  }

  render() {
    const { showLoading, autoPlay, selectedIndex } = this.state;
    const { i18n, userInfo, paperInfo, themeColor, videoUrl } = this.props;
    //试题信息
    const interviewQuesVOs = paperInfo.interviewQuesVOs;
    return (
      <div className="queVideo mrg25">
        <Title iconfont="icon-question1">
          {{
            title: <React.Fragment>{i18n.result.videoTitle}<span className="total"> ( {i18n.result.total.replace('{num}', interviewQuesVOs && interviewQuesVOs.length || 0)} )</span></React.Fragment>,
            // content: (userInfo && userInfo.aiVaild === 1 && userInfo.reportStatus !== 2) && <Button loading={userInfo.reportStatus === 1 || showLoading} onClick={() => this.generateReport()} type="primary" style={{backgroundColor: themeColor}}>{i18n.report.generateReport}</Button>
          }}
        </Title>
        <div className="queVideoContent pad60 padt16">
          <OtherVideo videoUrl={videoUrl}
                      selectedIndex={selectedIndex} paperInfo={paperInfo}
                      handleClick={this.handleClick} themeColor={themeColor} autoPlay={autoPlay} />
          <div className="interviewQuesBox">
            <InterviewQues handleClick={this.handleClick} selectedIndex={selectedIndex}
                           interviewQuesVOs={interviewQuesVOs} i18n={i18n} themeColor={themeColor} />
          </div>
        </div>
      </div>
    );
  }
}

export default QueVideo;
